'use client';

import dynamic from 'next/dynamic';

export const JobApplicationForm = dynamic(() =>
  import('./JobApplicationForm').then((m) => m.JobApplicationForm)
);
